export default __webpack_public_path__ + "static/media/tiki.59590232.jpg";